import { z } from 'zod'
import { oc } from '@orpc/contract'
import { cellRefSchema } from '../../boards/handlers/boards-shared.contract'

const faxTaskSummarySchema = z.object({
  documentReferenceId: z.string(),
  tasks: z.array(
    z.object({
      itemId: z.string(),
      boardId: z.string(),
      name: z.string(),
      actions: z.array(z.string()),
      status: z.string().nullable(),
      owner: cellRefSchema.nullable(),
      dueDate: z.string().nullable(),
      priority: z.string().nullable(),
      done: z.boolean(),
      overdue: z.boolean(),
      completion: z.object({ note: z.string(), by: cellRefSchema, at: z.string() }).nullable(),
    }),
  ),
  state: z.enum(['none', 'pending', 'overdue']),
})

export const faxTaskSummaries = oc
  .route({ method: 'POST', path: '/v2/fax-tasks/summaries' })
  .input(z.object({ documentReferenceIds: z.array(z.string().min(1)).min(1).max(100) }))
  .output(z.object({ summaries: z.array(faxTaskSummarySchema) }))
